import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useAuth } from "../../context/auth";
import Paperplane from "../elements/Paperplane";
import { useForm } from "react-hook-form";
import { navigate } from "@reach/router";
import authHeader from "../../services/auth.header";
import axios from "axios";
const Header = styled.h1`
  margin-top: 20px;
  margin-left: 14px;
  font-family: PlayfairDisplay;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: #fffcf2;
`;

const FormLabel = styled.h1`
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 26px;
  letter-spacing: 0.005em;
  color: #fffcf2;
  margin-left: 20px;
`;

const FormInput = styled.input`
  padding: 16px 28px;
  border: none;
  background: #2f2323;
  backdrop-filter: blur(10px);
  border-radius: 50px;
  position: static;
  color: #fffcf2;
  width: 100%;
  font-family: Poppins;
  &:focus {
    outline: none;
  }
`;
const Desc = styled.text`
  width: 326px;
  height: 140px;
  font-family: Poppins;
  font-size: 11px;
  line-height: 20px;
  letter-spacing: 0.1px;
  text-align: left;
  color: #ffffff;
`;

const NextBtn = styled.button`
  background: linear-gradient(
    90deg,
    #f89825 0%,
    #f26322 17.75%,
    #e5333b 46.66%,
    #c81d5e 86.72%,
    #a91e5e 97.37%
  );
  border-radius: 64px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 15px 50px;
  border: none;
  position: static;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 26px;
  color: #fdfffc;
  margin: auto;
  text-align: center;
  letter-spacing: 0.005em;
  &:disabled {
    background: #808080;
  }
`;

export default function CurrencyPrompt(props) {
  const { user } = useAuth();
  const text = "Currency changed!";
  const currency = props.currency;
  const check = props;
  console.log("check currency", check);
  const BASE_URL = "https://catway.services.ombre.app/v1/";

  const [showOverlay, setShowOverlay] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({});

  const onSubmit = (data) => {
    return axios
      .put(
        BASE_URL +
          "users/" +
          `${user && user.data ? user.data.id : user.id}` +
          "/profile" +
          "/settings",
        {
          currency: currency,
          password: data.password,
        },
        {
          headers: authHeader(),
        }
      )
      .then(() => {
        setShowOverlay(true);
        setTimeout(() => {
          navigate("/profile");
        }, 3000);
      });
  };
  return (
    <>
      <Paperplane active={showOverlay} text={text}>
        <Header style={{ marginTop: "70px" }}>Verify your password</Header>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mt-5">
            <FormLabel>Re-enter your password to continue:</FormLabel>
          </div>
          <div className="d-flex px-3">
            <FormInput
              type="password"
              placeholder="enter your password"
              {...register("password")}
            />
          </div>
          <div style={{ marginTop: "20px", marginBottom: "30px" }}>
            <NextBtn type="submit">Verify</NextBtn>
          </div>
        </form>
      </Paperplane>
    </>
  );
}
